import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/layout/index'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '仪表盘', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/products',
    component: () => import('@/views/layout/index'),
    redirect: '/products/list',
    meta: { title: '产品管理', icon: 'el-icon-s-goods' },
    children: [
      {
        path: 'list',
        name: 'ProductList',
        component: () => import('@/views/products/list'),
        meta: { title: '产品列表' }
      },
      {
        path: 'create',
        name: 'CreateProduct',
        component: () => import('@/views/products/form'),
        meta: { title: '新增产品' },
        hidden: true
      },
      {
        path: 'edit/:productId',
        name: 'EditProduct',
        component: () => import('@/views/products/form'),
        meta: { title: '编辑产品' },
        hidden: true
      }
    ]
  },
  {
    path: '/categories',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'Categories',
        component: () => import('@/views/categories/index'),
        meta: { title: '分类管理', icon: 'el-icon-s-grid' }
      }
    ]
  },
  {
    path: '/company',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'Company',
        component: () => import('@/views/company/index'),
        meta: { title: '公司信息', icon: 'el-icon-office-building' }
      }
    ]
  },
  // 注意：/cases 已移除，统一使用 /case-studies 作为客户案例管理
  {
    path: '/faq',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'FAQ',
        component: () => import('@/views/faq/index'),
        meta: { title: '常见问题', icon: 'el-icon-question' }
      }
    ]
  },
  {
    path: '/advantages',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'Advantages',
        component: () => import('@/views/advantages/index'),
        meta: { title: '核心优势', icon: 'el-icon-star-on' }
      }
    ]
  },
  {
    path: '/process',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'Process',
        component: () => import('@/views/process/index'),
        meta: { title: '服务流程', icon: 'el-icon-s-claim' }
      }
    ]
  },
  {
    path: '/inquiries',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'Inquiries',
        component: () => import('@/views/inquiries/index'),
        meta: { title: '咨询管理', icon: 'el-icon-s-order' }
      }
    ]
  },
  {
    path: '/site-config',
    component: () => import('@/views/layout/index'),
    children: [
      {
        path: '',
        name: 'SiteConfig',
        component: () => import('@/views/site-config/index'),
        meta: { title: '网站配置', icon: 'el-icon-s-tools' }
      }
    ]
  },
  {
    path: '/case-studies',
    component: () => import('@/views/layout/index'),
    redirect: '/case-studies/list',
    meta: { title: '案例管理', icon: 'el-icon-s-cooperation' },
    children: [
      {
        path: 'list',
        name: 'CaseStudyList',
        component: () => import('@/views/case-studies/list'),
        meta: { title: '案例列表' }
      },
      {
        path: 'create',
        name: 'CreateCaseStudy',
        component: () => import('@/views/case-studies/form'),
        meta: { title: '新增案例' },
        hidden: true
      },
      {
        path: 'edit/:id',
        name: 'EditCaseStudy',
        component: () => import('@/views/case-studies/form'),
        meta: { title: '编辑案例' },
        hidden: true
      }
    ]
  },
  // {
  //   path: '/i18n',
  //   component: () => import('@/views/layout/index'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'Translations',
  //       component: () => import('@/views/i18n/translations'),
  //       meta: { title: '翻译管理', icon: 'el-icon-translation' }
  //     }
  //   ]
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.state.user.isLoggedIn

  if (to.path === '/login') {
    if (isLoggedIn) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (isLoggedIn) {
      next()
    } else {
      try {
        await store.dispatch('user/getInfo')
        next()
      } catch (error) {
        next(`/login?redirect=${to.path}`)
      }
    }
  }
})

export default router
